import { Languages } from '@ratehub/base-ui';

import getCreditCardURL, { CC_URL_SLUGS } from '../functions/getCreditCardURL';

import PROVIDER_INFO from '../definitions/ProviderInfo';


// the cardInfo object is the first argument because in the future we expect it to
// contain the FR URL slug as well, so this function’s signature won’t have to change

/**
 * get the proper name of the indicated credit card provider (e.g. its bank)
 * @param {object} cardInfo
 * @param {string} cardInfo.bank English language slug for a credit card provider
 * @param {string} language en or fr
 * @return {string} Ratehub’s landing page URL for the credit card provider, using
 *              the EN slug if no FR one is available
 */

export default function getCardProviderLandingPage({ bank }, language) {
    return language === Languages.FRENCH
        ? getCreditCardURL(Languages.FRENCH, CC_URL_SLUGS.BASE, PROVIDER_INFO[bank].slug_fr || bank)
        : getCreditCardURL(Languages.ENGLISH, CC_URL_SLUGS.BASE, bank);
}
